import { isNil, isObject } from 'lodash'

const Plugin = {
  install(Vue, opt = {}) {
    const modalMap = Object.create(null)

    function getInstanceContainer() {
      return opt.containerSelector ?? document.body
    }

    /**
     * 删除模态框
     * @param  {[type]} key [删除的modalKey，不传删除所有]
     * @return {[type]}     [description]
     */
    function closeModal(key) {
      if (key) {
        modalMap[key].remove()
      } else {
        Object.values(modalMap).forEach(el => {
          el.remove()
        })
      }
      return modalMap
    }

    function openDynamicComponent(
      ModalComponent,
      componentOpt,
      key = 'default'
    ) {
      let instance = modalMap[key]
      // 如果已有，就将之前的删除
      if (instance) closeModal(key)

      // @warn 如果调用方法者为vue组件，则将设置为parent注入
      // 因无parent注入，直接插入dom会造成控件store,router等丢失（因没有完整父子链）
      const parent = isObject(this) && this._isVue ? this : undefined

      instance = new Vue({
        name: 'DynamicNodeComponentUtilElement',
        parent,

        methods: {
          remove() {
            // 设置modal关闭
            this.$children[0].visible = false

            // 等待动画结束，销毁实例
            // setTimeout(() => {
            //   this.destroy()
            // }, 300)
          },
          destroy() {
            getInstanceContainer().removeChild(this.$el)
            this.$destroy()

            delete modalMap[key]
          }
        },

        render(h) {
          return h(ModalComponent, { ...componentOpt })
        }
      })

      // 缓存当前实例
      modalMap[key] = instance

      // 渲染代理组件，并添加到dom中
      const component = instance.$mount()
      getInstanceContainer().appendChild(component.$el)

      // 获取Modal Vue实例，
      const $modal = instance.$children[0]

      $modal?.$children?.[0].$once('closed', function() {
        instance.destroy()
      })

      // 展示组件支持此方法调用
      if (!isNil($modal.visible)) {
        // 手动设置visible打开Modal
        $modal.visible = true

        // 监听visible属性关闭
        const unwatch = $modal.$watch('visible', function(val) {
          !val && instance.remove()
          unwatch && unwatch()
        })
      } else {
        instance.destroy()
        throw new Error(
          '组件不支持使用此方法展示！请在组件中data属性上添加visible属性'
        )
      }

      return instance
    }

    // 原型链注入方法
    Vue.prototype.$openDynamicComponent = openDynamicComponent
    Vue.prototype.$closeDynamicComponent = closeModal

    if (opt.useRouterClose) {
      // 路由切换时，清除所有弹出
      Vue.mixin({
        beforeRouteLeave(to, from, next) {
          Object.keys(modalMap).length && closeModal()
          next()
        }
      })
    }
  }
}

export default Plugin
